var _path, _g, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "54.25px",
    height: "60px",
    viewBox: "0 0 54.25 60",
    enableBackground: "new 0 0 54.25 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111111",
    d: "M22.798,58.836L4.348,48.184C1.657,46.631,0,43.76,0,40.652V19.348c0-3.107,1.657-5.978,4.348-7.531 l18.45-10.652c2.69-1.553,6.005-1.553,8.696,0l18.449,10.652c2.691,1.553,4.348,4.424,4.348,7.531v21.304 c0,3.107-1.656,5.979-4.348,7.531L31.494,58.836C28.803,60.389,25.488,60.389,22.798,58.836z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M12.409,35.663h11.78l-10.385-8.082c-2.218-1.726-2.674-4.898-1.031-7.179l2.556-3.547 c1.373-1.905,3.578-3.035,5.926-3.035h13.393c3.41,0,6.176,2.765,6.176,6.176v4.34H28.842l10.555,7.917 c2.319,1.74,2.779,5.036,1.023,7.344l-2.813,3.7c-1.382,1.815-3.532,2.882-5.813,2.882H18.585c-3.411,0-6.176-2.765-6.176-6.176 V35.663z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    d: "M18.385,14.422c-0.05,0.021-0.101,0.043-0.151,0.066l10.606,9.849h3.895L18.385,14.422z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    d: "M34.738,45.547l-10.549-9.884h-3.051l13.484,9.934C34.661,45.58,34.7,45.564,34.738,45.547z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.930821c6866cbf52a73c277fe90c5264.svg";
export { ForwardRef as ReactComponent };